// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const loadProtobuf = () => import(/* webpackChunkName: "4-feat-protobuf-root" */ './protobufRoot');
